import { Fragment } from 'react';
import type { PlayerClozePayload } from '@/services/quizzes';
import styles from './QuizQuestion.module.scss';

interface ClozeQuestionProps {
  payload: PlayerClozePayload;
  value: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
  reveal?: boolean;
}

// El template tiene marcadores `{N}` que se reemplazan por inputs inline.
// Si no hay placeholder, se renderiza el texto plano (paridad WP Pro Quiz: el contenido se interpreta literal).
export function ClozeQuestion({ payload, value, onChange, disabled, reveal }: ClozeQuestionProps) {
  const blankCount = payload.blank_count ?? payload.blanks?.length ?? 0;
  const parts = payload.template.split(/(\{\d+\})/g);

  function setBlank(idx: number, v: string) {
    const next = [...value];
    while (next.length < blankCount) next.push('');
    next[idx] = v;
    onChange(next.slice(0, blankCount));
  }

  return (
    <p className={styles.clozeWrap}>
      {parts.map((segment, i) => {
        const m = segment.match(/^\{(\d+)\}$/);
        if (m) {
          const idx = Number(m[1]);
          const blank = payload.blanks?.[idx];
          const accepted = reveal ? blank?.accepted?.[0] ?? '' : null;
          return (
            <Fragment key={i}>
              <input
                type="text"
                value={value[idx] ?? ''}
                onChange={(e) => setBlank(idx, e.target.value)}
                disabled={disabled}
                aria-label={`Hueco ${idx + 1}`}
              />
              {reveal && accepted && (
                <span style={{ color: 'var(--color-success-700, #15803d)', marginLeft: 4 }}>
                  ({accepted})
                </span>
              )}
            </Fragment>
          );
        }
        return <Fragment key={i}>{segment}</Fragment>;
      })}
    </p>
  );
}
